import { Navigate, useLocation } from "react-router-dom";


const ProtectedRouteCourier = ({ children, isAuthenticated, completeProfile, showReferalPage }) => {

	const location = useLocation();

    if (!isAuthenticated) {
    	if( location.pathname )
    		localStorage.setItem("backUrl", location.pathname);
        return <Navigate to="/courier/login" replace />;
    }

    return children;
}

export default ProtectedRouteCourier;
